import { Avatar, Button, Dropdown, Typography } from "antd";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import useFormattedDate from "hooks/useFormatDate";
import MentionEditor from "../../common/MentionEditor";

const { Text } = Typography;

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }
  return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
};

const CommentItem = ({
  comment,
  editingId,
  setEditingId,
  editingText,
  setEditingText,
  mentionUsers = [],
  onDelete,
  onSave,
  user,
}) => {
  const isEditing = editingId === comment.id;
  const { formatDateTime } = useFormattedDate();

  const items = [
    {
      key: "edit",
      icon: <EditOutlined />,
      label: "Edit",
      onClick: () => {
        setEditingId(comment.id);
        setEditingText(comment.content);
      },
    },
    {
      key: "delete",
      icon: <DeleteOutlined />,
      label: "Delete",
      danger: true,
      onClick: () => onDelete(comment.id),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: 12,
        position: "relative",
      }}
    >
      <Avatar>{getInitials(comment?.createdByName)}</Avatar>

      <div style={{ flex: 1 }}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <div>
            <Text style={{ fontSize: 13, fontFamily: "Inter" }} strong>
              {comment?.createdByName}
            </Text>
            <Text
              type="secondary"
              style={{ fontSize: 11, marginLeft: 8, fontFamily: "Inter" }}
            >
              {formatDateTime(comment.createdAt)}
            </Text>
          </div>

          {/* Context Menu */}
          {comment.createdByName === user && (
            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              placement="bottomRight"
            >
              <MoreOutlined
                onClick={(e) => e.stopPropagation()}
                style={{
                  cursor: "pointer",
                  color: "#9ca3af",
                  fontSize: 16,
                }}
              />
            </Dropdown>
          )}
        </div>

        {/* Body */}
        {!isEditing ? (
          <div
            style={{
              background: "#f9fafb",
              padding: 12,
              borderRadius: 8,
              border: "1px solid #e5e7eb",
            }}
          >
              <div
                style={{ color: "#374151", fontSize: 13 }}
                dangerouslySetInnerHTML={{
                  __html: comment.content || "<p></p>",
                }}
              />
          </div>
        ) : (
          <div>
            <MentionEditor
              value={editingText}
              onChange={setEditingText}
              placeholder="Update comment..."
              users={mentionUsers}
              debugId="TaskDrawer:EditComment"
              className="mb-0"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 8,
              }}
            >
              <Button onClick={() => setEditingId(null)}>Cancel</Button>
              <Button type="primary" onClick={() => onSave(comment.id)}>
                Save
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentItem;
